import Button from "@material-ui/core/Button";
import { Box, Stack, ThemeProvider, Typography } from "@mui/material";
import LoadingButton from "components/button/LoadingButton";
import Modal from "components/modal/Modal";
import { useBlockUser } from "service/query/user.query";
import muiTheme from "theme/muiTheme";

const DialogBlockUser = ({ open, onClose, user }) => {
  const { mutate: blockUser, isPending } = useBlockUser();
  const handleBlockUser = () => {
    blockUser(user.id, {
      onSuccess: onClose,
    });
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <Modal
        open={open}
        onClose={onClose}
        title={"Khóa tài khoản"}
        maxWidth="xs">
        <Box>
          <Typography>
            Bạn đồng ý khóa tài khoản{" "}
            <Typography
              component="span"
              color={(theme) => theme.palette.error.main}>
              {user.username}
            </Typography>{" "}
            không?
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
          <Button onClick={onClose} color="secondary">
            Hủy
          </Button>
          <LoadingButton
            onClick={handleBlockUser}
            variant="contained"
            color="primary"
            loading={isPending}>
            Đồng ý
          </LoadingButton>
        </Stack>
      </Modal>
    </ThemeProvider>
  );
};

export default DialogBlockUser;
